import { object, string } from 'yup';

import ssnRegex from '@/ui/components/Form/SSNInput/ssnRegex';

export const ssnSchema = object().shape({
  ssn: string()
    .matches(ssnRegex, 'SSN must be 9 digits and only contain spaces or hyphens')
    .required('SSN is required')
    .label('Social Security Number')
    .trim()
    .transform((value: string) => value.replace(/[^0-9]/g, ''))
});
